import { render, staticRenderFns } from "./FundingInfo.vue?vue&type=template&id=42281a7b&"
import script from "./FundingInfo.vue?vue&type=script&lang=ts&"
export * from "./FundingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FundingInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports